import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { isPathMode } from '../config/markets';

/**
 * MarketLink — slug-aware <Link> wrapper.
 *
 * In path-mode (OTC on offtheclockspots.com), prepends /:marketSlug to absolute paths.
 * In env-mode (TCC), behaves exactly like <Link>.
 *
 * Usage:
 *   <MarketLink to="/admin">Admin</MarketLink>
 *   // → <Link to="/naperville/admin"> (path-mode) or <Link to="/admin"> (env-mode)
 */
export function MarketLink({ to, ...props }) {
  const params = useParams();
  const slug = params.marketSlug;

  const resolvedTo = (isPathMode() && slug && typeof to === 'string' && to.startsWith('/'))
    ? `/${slug}${to}`
    : to;

  return <Link to={resolvedTo} {...props} />;
}

export default MarketLink;
